module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_000.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_000.png
// module id = 2347
// module chunks = 5